/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DashboardDailyTokensViewModel } from "../types/DashboardDailyTokensViewModel.ts";

export const dashboardDailyTokensViewModelSchema = z.object({
  date: z.string().nullish(),
  tokensUsed: z.optional(z.number().int()),
}) as unknown as ToZod<DashboardDailyTokensViewModel>;
